import axios from '@utils/axios'
import Emitter from '@utils/eventEmitter'

const errorMessage = async (status, url, message) => {
  const location = window.location
  switch (status) {
    case 401:
      if (message === 'duplicate session') {
        Emitter.emit('SHOW_MESSAGE', {
          text: '다른 PC에서 로그인하여 로그아웃 되었습니다.',
          color: 'warning'
        })
        localStorage.removeItem('accessToken')
        localStorage.removeItem('refreshToken')
        setTimeout(() =>
          location.href = location.origin
        , 2000)
        return
      }
      if (message === 'Invalid JWT signification' || message === 'Already logged out user') {
        Emitter.emit('SHOW_MESSAGE', {
          text: '로그인 세션이 만료되었습니다.',
          color: 'warning'
        })
        localStorage.removeItem('accessToken')
        localStorage.removeItem('refreshToken')

        setTimeout(() =>
            location.href = location.origin
          , 2000)
      } else {
        Emitter.emit('SHOW_MESSAGE', {
          text: message,
          color: 'warning'
        })
      }
      break
    case 403:
      Emitter.emit('SHOW_MESSAGE', {
        text: '권한이 없습니다.',
        color: 'error'
      })
      break
    case 404:
      Emitter.emit('SHOW_MESSAGE', {
        text: message,
        color: 'error'
      })
      break
    case 412:
      Emitter.emit('SHOW_MESSAGE', {
        text: '조건에 부합하지 않습니다.',
        color: 'error'
      })
      break
    case 400:
      Emitter.emit('SHOW_MESSAGE', {
        text: message,
        color: 'warning'
      })
      break
    default:
      if (url.indexOf('check') !== -1) {
        return
      }
      Emitter.emit('SHOW_MESSAGE', {
        text: message || '관리자에게 문의 부탁드려요.',
        color: 'error'
      })
  }
}

const apiRequest = async ({ method, url, data, params, body, headers, responseType }) => {
  const options = {
    method,
    url,
    data,
    params,
    body,
    headers: {
      ...headers,
    },
    withCredentials: false,
    responseType
  }

  const accessToken = localStorage.getItem('accessToken')

  if (accessToken) {
    axios.defaults.headers.common["Authorization"] = `Bearer ${accessToken}`
  } else {
    delete axios.defaults.headers.common['Authorization']
  }
  try {
    const response = await axios(options)
    return response ? response.data : null
  } catch (error) {
    let lCatchResponse = error.response
    let message = lCatchResponse.data.result
    errorMessage(lCatchResponse.status, lCatchResponse.config.url, message)
    let lRetCatchResponse = {
      __isError: true
    }
    for (let key in lCatchResponse) {
      lRetCatchResponse[key] = lCatchResponse[key]
    }
    return lRetCatchResponse
  }
}

export default apiRequest
